module.exports = __webpack_public_path__ + "3810e7ff4bd2df23b80cc78d54dc3675.MP3";